import * as angular from "angular";

export class ExpensesCategoriesRequests {

  constructor(private ExpensesCategoriesApi, private $expensesCategories) {
  }

  createCategory(category) {
    const api = this.ExpensesCategoriesApi.actions.createCategory;
    return this.$$call(api, {}, category, {});
  }

  updateCategory(category) {
    const api = this.ExpensesCategoriesApi.actions.updateCategory;
    return this.$$call(api, {}, category, {id: category.id});
  }

  archiveCategory(categoryId) {
    const api = this.ExpensesCategoriesApi.actions.archiveCategory;
    return this.$$call(api, {}, {}, {id: categoryId});
  }

  private $$call(_apiCall, _params, _data, _options) {
    return this.$expensesCategories().$call(_apiCall, _params, _data, _options);
  }
}

angular
  .module('bringoz.admin.expenses')
  .service('expensesCategoriesRequests', ExpensesCategoriesRequests);

